// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.5171 2.02905L22.0884 6.68042L22.019 7.17065L19.896 22.0291H11.8091L14.2095 10.0291H15.6147L12.6948 7.10913L12.5151 8.19312L12.3755 9.02905H7.89697L8.56396 10.0291H12.2485L9.84814 22.0291L1.91162 22.0281L4.1333 2.02905H17.5171ZM14.2485 20.0291H18.1616L19.3042 12.0291H15.8481L14.2485 20.0291ZM4.146 20.0281H8.2085L9.80908 12.0291H7.49365L5.38623 8.86792L4.146 20.0281ZM19.4458 11.032L19.9683 7.37671L16.6792 4.02905H12.4429L19.4458 11.032ZM5.59033 7.02905H10.6821L11.1821 4.02905H5.92432L5.59033 7.02905Z"}}]};

const LogoWechatWorkdocsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-wechat-workdocs',
    ref,
    icon: element,
  },
));

LogoWechatWorkdocsIcon.displayName = 'LogoWechatWorkdocsIcon';

export default LogoWechatWorkdocsIcon;
